/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Video_CompleteInputs */



/**
* | output |
* | --- |
* | "Video export complete!" |
*
* @param {Audio_Description_Export_Status_Video_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_complete = /** @type {((inputs?: Audio_Description_Export_Status_Video_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation vidéo terminée !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videoexport abgeschlossen!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione video completata!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео завершен!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Exportación de vídeo completada!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频导出完成！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオのエクスポートが完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो एक्सपोर्ट पूरा हुआ!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação de vídeo concluída!")
	return /** @type {LocalizedString} */ ("Video export complete!")
});